var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUploadSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.139,
    height: 21.731,
    viewBox: "0 0 17.139 21.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "document",
    d: "M5.557,24.109H16.289a3.234,3.234,0,0,0,2.4-.814,3.309,3.309,0,0,0,.8-2.42V11.722a7.406,7.406,0,0,0-.075-1.148,2.563,2.563,0,0,0-.29-.854,3.981,3.981,0,0,0-.639-.816L13.064,3.392a3.144,3.144,0,0,0-1.192-.816,4.719,4.719,0,0,0-1.49-.2H5.557a3.226,3.226,0,0,0-2.4.818,3.313,3.313,0,0,0-.809,2.425V20.875a3.3,3.3,0,0,0,.809,2.42A3.237,3.237,0,0,0,5.557,24.109Zm.121-1.81a1.505,1.505,0,0,1-1.128-.388,1.539,1.539,0,0,1-.377-1.117V5.7A1.531,1.531,0,0,1,4.555,4.59,1.511,1.511,0,0,1,5.688,4.2h4.386V9.874a2.071,2.071,0,0,0,.505,1.524,2.057,2.057,0,0,0,1.514.505h5.589v8.89A1.353,1.353,0,0,1,16.158,22.3Zm6.61-12.039a.5.5,0,0,1-.581-.581V4.487l5.686,5.774Z",
    transform: "translate(-2.354 -2.378)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadSmall);
export default __webpack_public_path__ + "static/media/document-upload-small.8730b9b03422bffff8784f3b54b4e80a.svg";
export { ForwardRef as ReactComponent };